import { render, staticRenderFns } from "./BillingAndPayment.vue?vue&type=template&id=0227710d&lang=pug"
import script from "./BillingAndPayment.vue?vue&type=script&lang=js"
export * from "./BillingAndPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports